import React, { useState } from 'react';
import Icon from '../AppIcon';
import { useCompanySettings } from '../../contexts/CompanySettingsContext';

const BiometricSecurityDisclaimer = () => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [isDismissed, setIsDismissed] = React.useState(false);
  const { companySettings } = useCompanySettings();

  const companyLegalName = companySettings?.companyLegalName || companySettings?.companyName || 'Your Company';

  if (isDismissed) return null;

  return (
    <div className="bg-warning/10 border-t border-b border-warning/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <Icon name="Shield" size={20} className="text-warning" />
          </div>
          <div className="flex-1">
            <div className="flex items-start justify-between mb-2">
              <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
                Biometric Data & Payroll Integration Security Notice
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={16} />
                </button>
              </h3>
              <button
                onClick={() => setIsDismissed(true)}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                <Icon name="X" size={16} />
              </button>
            </div>
            
            {isExpanded ? (
              <div className="text-sm text-foreground space-y-3">
                <div>
                  <p className="font-semibold mb-1">Biometric Data Handling</p>
                  <p>
                    This application integrates with time and attendance systems that use biometric authentication (facial recognition, fingerprint, card access). All biometric data is stored and processed by your chosen attendance system provider. This application only stores biometric registration IDs and access logs for audit purposes.
                  </p>
                </div>
                <div>
                  <p className="font-semibold mb-1">Payroll Data Security</p>
                  <p>
                    Payroll data imported from external providers (ABLE, Smoothpay, BSP Quick Pay, ALESCO) is transmitted securely and stored with encryption. API credentials are encrypted at rest. CSV and Excel imports are processed in memory and not stored permanently unless explicitly saved.
                  </p>
                </div>
                <div>
                  <p className="font-semibold mb-1">Data Validation & Compliance</p>
                  <p>
                    All imported payroll data is automatically validated against Papua New Guinea labor laws including minimum wage requirements, overtime calculations, and NASFUND contribution rates. Validation results and audit logs are maintained for compliance reporting.
                  </p>
                </div>
                <div>
                  <p className="font-semibold mb-1">Third-Party Integration Disclaimer</p>
                  <p>
                    Integration with external payroll and attendance systems is provided for convenience. {companyLegalName} is not responsible for data accuracy, availability, or security practices of third-party providers. Users should verify all imported data and maintain independent records.
                  </p>
                </div>
                <div>
                  <p className="font-semibold mb-1">User Responsibilities</p>
                  <p>
                    Employers must ensure compliance with PNG Privacy Act and obtain appropriate employee consent for biometric data collection. Users are responsible for securing API credentials and limiting access to sensitive payroll information. Regular security audits and access reviews are recommended.
                  </p>
                </div>
              </div>
            ) : (
              <p className="text-sm text-muted-foreground">
                This application integrates with biometric attendance systems and external payroll providers. All data is handled securely with encryption and validated against PNG labor laws. Click to read full security notice.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiometricSecurityDisclaimer;